"use client";

import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { getAppTitle } from "@/lib/appTitle";

export function DynamicTitle() {
  const { language } = useLanguage();

  // Set title immediately on mount and whenever language changes
  useEffect(() => {
    const title = getAppTitle(language);
    document.title = title;
    document.documentElement.lang = language === "zh" ? "zh" : "en";
  }, [language]);

  return null;
}
